import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const UserInfo = ({name, login}) => {
  const { t } = useTranslation('common')

  return (
    <div className='registracija-content-welcome'>
      <p>{t('Zdravo')} <span>{name} ({login})</span></p>
    </div>
  )
}

UserInfo.propTypes = {
  login: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}
